import { Description } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FunctionField, useTranslate } from "react-admin";

import { ProcedureRecord } from "../../types/procedure";

type DocumentationButtonFieldProps = {
  label: string;
  getContent: (record: ProcedureRecord) => string | null | undefined;
  onDocumentationClick: (title: string, content: string) => void;
};

export const DocumentationButtonField = ({
  label,
  getContent,
  onDocumentationClick,
}: DocumentationButtonFieldProps) => {
  const translate = useTranslate();

  return (
    <FunctionField
      label={label}
      render={(record: ProcedureRecord) => {
        const content = getContent(record);
        if (!content) return null;

        const handleClick = (event: React.MouseEvent) => {
          event.stopPropagation();
          const title = translate("documentationModal.title");
          onDocumentationClick(title, content);
        };

        return (
          <IconButton size="small" onClick={handleClick} aria-label={label}>
            <Description />
          </IconButton>
        );
      }}
    />
  );
};
